import InterfaceAsesmenRisikoJatuh from "../apiInterface/InterfaceAsesmenRisikoJatuh";
import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

class DataAsesmenRisikoJatuh {
  async getDataAsesmenRisikoJatuh(unit, reg) {
    let dt: any;
    await InterfaceAsesmenRisikoJatuh.getAsesmenRisikoJatuh(unit, reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Asesmen Risiko Jatuh");
      });
    return dt;
  }

  async getDataRiwayatAsesmenRisikoJatuh(rm) {
    let dt: any;
    await InterfaceAsesmenRisikoJatuh.getRiwayatAsesmenRisikoJatuh(rm)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Riwayat Asesmen Risiko Jatuh");
      });
    return dt;
  }

  async saveDataAsesmenRalan(
    reg,
    rm,
    unit_id,
    petugas_id,
    risiko,
    waktu_periksa
  ) {
    let dt: object = {};
    await InterfaceAsesmenRisikoJatuh.saveAsesmenRisikoJatuh(
      reg,
      rm,
      unit_id,
      petugas_id,
      risiko,
      waktu_periksa
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataAsesmenRalan(id, petugas_id, risiko, waktu_periksa) {
    let dt: object = {};
    await InterfaceAsesmenRisikoJatuh.editAsesmenRisikoJatuh(
      id,
      petugas_id,
      risiko,
      waktu_periksa
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async delete(id) {
    const response = await http
      .deleteData(`/asesmen-risiko-jatuh-ralan/${id}`)
      .catch(e => {
        ErrorAlert.showErrorAlert(e);
      });

    return response["data"];
  }
}

export default new DataAsesmenRisikoJatuh();
